import React, { useEffect, useState } from "react";
import {
  Container,
  Box,
  TextField,
  Typography,
  Paper,
  InputAdornment,
  Grid,
  Button,
} from "@mui/material";
import {
  AccountCircle,
  AddReaction,
  ContactPhone,
  MarkEmailRead,
  Portrait,
} from "@mui/icons-material";
import { useSelector, useDispatch } from "react-redux";
import { profileInformation } from "../../features/Dev/devSlice";

const UserInfo = () => {
  const [userData, setUserData] = useState({
    first_name: "",
    last_name: "",
    name: "",
    email: "",
    phone: "",
    photo_url: "",
  });
  const { user } = useSelector((state) => state.auth);
  const { dev } = useSelector((state) => state.dev);

  const { firstName, lastName, name, email, phone, photo_url } = dev;

  useEffect(() => {
    setUserData({
      ...userData,
      first_name: firstName,
      last_name: lastName,
      name,
      email,
      phone,
      photo_url,
    });
  }, []);

  const dispatch = useDispatch();

  const handleChange = (event) => {
    setUserData({
      ...userData,
      [event.target.name]: event.target.value,
    });
  };

  const handleProfileInfo = (e) => {
    e.preventDefault();
    dispatch(profileInformation(userData));
  };

  return (
    <>
      {/* {JSON.stringify(userData)} */}
      <Container
        maxWidth="md"
        sx={{
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          height: "100%",
        }}
      >
        <Box>
          <Paper p={1} elevation={2}>
            <Box sx={{ p: 2 }} component="form" onSubmit={handleProfileInfo}>
              <Box>
                <Typography variant="h5">Edit Info</Typography>
              </Box>

              <Box py={2}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                      <AccountCircle
                        sx={{ color: "action.active", mr: 1, my: 0.5 }}
                      />
                      <TextField
                        id="input-with-sx"
                        label="First Name"
                        variant="standard"
                        fullWidth
                        placeholder={firstName}
                        name="first_name"
                        onChange={handleChange}
                        type="text"
                        required
                        value={userData.first_name}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                      <AccountCircle
                        sx={{ color: "action.active", mr: 1, my: 0.5 }}
                      />
                      <TextField
                        id="input-with-sx"
                        label="Last Name"
                        variant="standard"
                        // value={last_name}
                        placeholder={userData.lastName}
                        fullWidth
                        name="last_name"
                        onChange={handleChange}
                        type="text"
                        value={userData.last_name}
                        required
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                      <MarkEmailRead
                        sx={{ color: "action.active", mr: 1, my: 0.5 }}
                      />
                      <TextField
                        id="input-with-sx"
                        label="Email "
                        variant="standard"
                        fullWidth
                        type="email"
                        placeholder={email}
                        name="email"
                        onChange={handleChange}
                        value={userData.email}
                        required
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                      <ContactPhone
                        sx={{ color: "action.active", mr: 1, my: 0.5 }}
                      />
                      <TextField
                        id="input-with-sx"
                        label="Phone Number"
                        variant="standard"
                        fullWidth
                        type="number"
                        placeholder={phone}
                        name="phone"
                        onChange={handleChange}
                        value={userData.phone}
                        required
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                      <Portrait
                        sx={{ color: "action.active", mr: 1, my: 0.5 }}
                      />
                      <TextField
                        id="input-with-sx"
                        label="username "
                        variant="standard"
                        fullWidth
                        type="text"
                        placeholder={name}
                        name="name"
                        onChange={handleChange}
                        value={userData.name}
                        required
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                      <AddReaction
                        sx={{ color: "action.active", mr: 1, my: 0.5 }}
                      />
                      <TextField
                        id="input-with-sx"
                        label="photo url"
                        variant="standard"
                        fullWidth
                        type="url"
                        placeholder={photo_url}
                        name="photo_url"
                        onChange={handleChange}
                        value={userData.photo_url}
                        required
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Box>
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Button variant="outlined" size="large" type="submit">
                  Update Info
                </Button>
              </Box>
            </Box>
          </Paper>
        </Box>
      </Container>
    </>
  );
};

export default UserInfo;
